import { AuthModel, AuthRequestModel } from '@tsin-core/models/auth.model';

const ACTION_SCOPE = '[Auth]';

export class AuthenticateAction {
    static readonly type = `${ACTION_SCOPE} Login`;
    constructor(public payload: AuthRequestModel) {}
}

export class ValidateTokenAction {
    static readonly type = `${ACTION_SCOPE} Validate Token`;
    constructor(public payload: { token: string; refreshToken: string }) {}
}

export class RefreshTokenAction {
  static readonly type = `${ACTION_SCOPE} Refresh Token`;
  constructor(public payload: { refreshToken: string }) { }
}

export class LogoutAction {
    static readonly type = `${ACTION_SCOPE} Logout`;
}

/**
 * Directly set auth state from Cognito token exchange response.
 * Bypasses the backend /auth/me call so the auth guard passes immediately.
 */
export class SetAuthAction {
    static readonly type = `${ACTION_SCOPE} Set Auth`;
    constructor(public payload: { token: string; refreshToken: string | null; user: any }) {}
}

export class SetLoading {
    static readonly type = `${ACTION_SCOPE} Set Loading`;
    constructor(public loading: boolean) {}
}

export class SetError {
    static readonly type = `${ACTION_SCOPE} Set Error`;
    constructor(public error: string | null) {}
}
export class SetReferralJobSlug {
    static readonly type = `${ACTION_SCOPE} Set Referral Job Slug`;
    constructor(public payload: string) {}
}

export class CreateAccountWorkWithUs {
    static readonly type = `${ACTION_SCOPE} Create Account Work With Us`;
    constructor(
        public payload: {
            firstName: string;
            lastName: string;
            email: string;
            office: string;
            role: string;
            gender: string;
            dateOfBirth: string;
            password: string;
        }
    ) {}
}
